var _g, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path2, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _mask, _path3, _path4, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHowToUse4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 232,
    viewBox: "0 0 356 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2524_98368)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 13,
    width: 280,
    height: 156,
    rx: 10,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 83.6C46 80.5072 48.5072 78 51.6 78H155.9C158.993 78 161.5 80.5072 161.5 83.6V169H46V83.6Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54.4,
    y: 86.3999,
    width: 44.8,
    height: 44.8,
    rx: 2.8,
    fill: "#F3F4F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 104.8,
    y: 86.3999,
    width: 49,
    height: 8.4,
    rx: 0.7,
    fill: "#F3F4F6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 104.8,
    y: 100.4,
    width: 44.8,
    height: 5.6,
    rx: 0.7,
    fill: "#F9FAFB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 104.8,
    y: 111.6,
    width: 33.6,
    height: 5.6,
    rx: 0.7,
    fill: "#F9FAFB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 104.8,
    y: 122.8,
    width: 28.7,
    height: 5.6,
    rx: 0.7,
    fill: "#F3F4F6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 54.4,
    y: 139.6,
    width: 30.1,
    height: 21,
    rx: 2.8,
    fill: "#F3F4F6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 88.7,
    y: 139.6,
    width: 30.8,
    height: 21,
    rx: 2.8,
    fill: "#F3F4F6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 123.7,
    y: 139.6,
    width: 30.1,
    height: 21,
    rx: 2.8,
    fill: "#F3F4F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M194 83.6C194 80.5072 196.507 78 199.6 78H303.9C306.993 78 309.5 80.5072 309.5 83.6V169H194V83.6Z",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 202.4,
    y: 86.3999,
    width: 44.8,
    height: 44.8,
    rx: 2.8,
    fill: "#F3F4F6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 252.8,
    y: 86.3999,
    width: 49,
    height: 8.4,
    rx: 0.7,
    fill: "#F3F4F6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 252.8,
    y: 100.4,
    width: 44.8,
    height: 5.6,
    rx: 0.7,
    fill: "#F9FAFB"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 252.8,
    y: 111.6,
    width: 33.6,
    height: 5.6,
    rx: 0.7,
    fill: "#F9FAFB"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 252.8,
    y: 122.8,
    width: 28.7,
    height: 5.6,
    rx: 0.7,
    fill: "#F3F4F6"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 202.4,
    y: 139.6,
    width: 30.1,
    height: 21,
    rx: 2.8,
    fill: "#F3F4F6"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 236.7,
    y: 139.6,
    width: 30.8,
    height: 21,
    rx: 2.8,
    fill: "#F3F4F6"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 271.7,
    y: 139.6,
    width: 30.1,
    height: 21,
    rx: 2.8,
    fill: "#F3F4F6"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-20-inside-1_2524_98368",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95 47C95 42.5817 98.5817 39 103 39H252C256.418 39 260 42.5817 260 47V169H95V47Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95 47C95 42.5817 98.5817 39 103 39H252C256.418 39 260 42.5817 260 47V169H95V47Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5 47C93.5 41.7533 97.7533 37.5 103 37.5H252C257.247 37.5 261.5 41.7533 261.5 47H258.5C258.5 43.4101 255.59 40.5 252 40.5H103C99.4101 40.5 96.5 43.4101 96.5 47H93.5ZM260 169H95H260ZM93.5 169V47C93.5 41.7533 97.7533 37.5 103 37.5V40.5C99.4101 40.5 96.5 43.4101 96.5 47V169H93.5ZM252 37.5C257.247 37.5 261.5 41.7533 261.5 47V169H258.5V47C258.5 43.4101 255.59 40.5 252 40.5V37.5Z",
    fill: "#53B1FD",
    mask: "url(#path-20-inside-1_2524_98368)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 51,
    width: 64,
    height: 64,
    rx: 4,
    fill: "#F3F4F6"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 51,
    width: 70,
    height: 12,
    rx: 1,
    fill: "#F3F4F6"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 71,
    width: 64,
    height: 8,
    rx: 1,
    fill: "#F9FAFB"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 87,
    width: 48,
    height: 8,
    rx: 1,
    fill: "#F9FAFB"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 179,
    y: 103,
    width: 41,
    height: 8,
    rx: 1,
    fill: "#F3F4F6"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 107,
    y: 127,
    width: 43,
    height: 30,
    rx: 4,
    fill: "#F3F4F6"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 127,
    width: 44,
    height: 30,
    rx: 4,
    fill: "#F3F4F6"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 127,
    width: 43,
    height: 30,
    rx: 4,
    fill: "#F3F4F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88 87.3335L84 98.0002L73.3334 102L84 106L88 116.667L92 106L102.667 102L92 98.0002L88 87.3335Z",
    fill: "#2E90FA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M154 18.3335L150 29.0002L139.333 33.0002L150 37.0002L154 47.6668L158 37.0002L168.667 33.0002L158 29.0002L154 18.3335Z",
    fill: "#2E90FA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M263.667 127L259.667 137.667L249 141.667L259.667 145.667L263.667 156.333L267.667 145.667L278.333 141.667L267.667 137.667L263.667 127Z",
    fill: "#2E90FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2524_98368",
    x: 0,
    y: 0,
    width: 356,
    height: 232,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 12,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2524_98368"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2524_98368"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2524_98368",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToUse4);
export default __webpack_public_path__ + "static/media/how_to_use_4.1e2da155376fa7296298f18722aafd90.svg";
export { ForwardRef as ReactComponent };